import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function EditSupplierLineItemPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/cost-center/internal-line-items/edit/${id}`, { replace: true });
  }, [id, navigate]);

  return null;
}
